// extracted by mini-css-extract-plugin
export default {"list":"HourlyWage_list__17Wcb","row":"HourlyWage_row__1JCN4","placeholderImage":"HourlyWage_placeholderImage__Ax1QT"};